import { INTELLECTUAL_PROPERTY_VIOLATION_REPORT_URL } from '../constants';

export const openIntellectualPropertyReport = () => {
    window.open(INTELLECTUAL_PROPERTY_VIOLATION_REPORT_URL, '_blank');
};
